import React from "react";
import CheckIcon from "@mui/icons-material/Check";

import { QARequestButtonState } from "integration/api/Deal/models";
import { getQAButtonTitle } from "features/question-answer/helpers/string";

import { ButtonAnswer, ButtonConfirmed, ButtonDefault, ButtonQuestion } from "./styles";

export interface Props {
  state: QARequestButtonState | undefined;
  onClick: () => void;
}

const QAButton = ({ state, onClick }: Props) => {
  const title = getQAButtonTitle(state);

  switch (state) {
    case QARequestButtonState.HIDDEN:
      return null;

    case QARequestButtonState.REGISTRATION_CONFIRMED:
      return (
        <ButtonConfirmed>
          <CheckIcon />
          <span>{title}</span>
        </ButtonConfirmed>
      );

    case QARequestButtonState.VIEW_QUESTION:
      return (
        <ButtonQuestion onClick={onClick}>
          <div className="inner">{title}</div>
        </ButtonQuestion>
      );

    case QARequestButtonState.VIEW_ANSWER:
      return <ButtonAnswer onClick={onClick}>{title}</ButtonAnswer>;

    default:
      return <ButtonDefault onClick={onClick}>{title}</ButtonDefault>;
  }
};

export default QAButton;
